import React from 'react'
import PropTypes from 'prop-types'
import { Provider } from 'react-redux'

import rootReducer from '../reducers'
import configureStore from 'Shared/configureStore'
import SwapsContainer from './SwapsContainer'


const SwapsRoot = ({
  fetchInitialDataURL,
}) => {
  const state = {
    misc: {
      fetchInitialDataURL,
    },
  }

  const store = configureStore(rootReducer, state)

  return <Provider store={ store }><SwapsContainer></SwapsContainer></Provider>
}

SwapsRoot.propTypes = {
  fetchInitialDataURL: PropTypes.string.isRequired,
}

export default SwapsRoot
